import { getToken } from '@/utils/auth';
import { apiClient } from 'md-base-tools/apiClient';
import { ElMessage } from 'element-plus';

const header = {
  client: 4,
  user_id: getToken() ? getToken().split("#")[0] : "",
  userid: getToken() ? getToken().split("#")[0] : "",
  token: getToken() ? getToken().split("#")[1] : "",
};

const needLogin = false;
const responseType = 'blob';
const env = process.env.VUE_APP_ENV; // 环境

const apis = apiClient({
  env,
  header,
  needLogin,
});
const apisBlob = apiClient({
  env,
  header,
  needLogin,
  responseType,
});

export const update = (url, option, new_header) => {
  let formData = new FormData();
  for (let a in option) {
    formData.append(a, option[a]);
  }
  return apis({
    method: "post",
    url: url,
    props: formData,
    header: {
      ...header,
      ...new_header,
    },
  });
};
export const post = (url, option, new_header) => {
  return apis({
    method: "post",
    url: url,
    props: {
      json_type: 1,
      ...option,
    },
    header: {
      ...header,
      ...new_header,
    },
  });
};
export const get = (url, option, new_header) => {
  return apis({
    method: "get",
    url: url,
    props: {
      json_type: 1,
      ...option,
    },
    header: {
      ...header,
      ...new_header,
    },
  });
};

export const getInfo = async (url, option, new_header) => {
  const { data, status, message } = await apis({
    method: "get",
    url: url,
    props: {
      json_type: 1,
      ...option,
    },
    header: {
      ...header,
      ...new_header,
    },
  });
  if (status != 0) {
    ElMessage.error(message);
    throw new Error(message) 
  }
  return data;
};
export const postInfo = async (url, option, new_header) => {
  const { data, status, message } = await apis({
    method: "post",
    url: url,
    props: {
      json_type: 1,
      ...option,
    },
    header: {
      ...header,
      ...new_header,
    },
  });
  if (status != 0) {
    ElMessage.error(message);
    throw new Error(message) 
  }
  return data;
};
export const postBlob = (url, option, new_header) => {
  return apisBlob({
    method: "post",
    url: url,
    props: {
      json_type: 1,
      ...option,
    },
    header: {
      ...header,
      ...new_header,
    },
  });
};
export default apis;
